import { remult } from "remult";

export async function runWithOverrideSecurity<T>(method: () => Promise<T>) {
  const prevAllowedOverrideSecurity = remult.context.shouldOverrideSecurity;
  try {
    remult.context.shouldOverrideSecurity = true;
    return await method();
  } finally {
    remult.context.shouldOverrideSecurity = prevAllowedOverrideSecurity;
  }
}
